import moment from 'moment';
import _ from 'underscore';
import parseError from '../../../parseError.js';
import { Toast } from '../../../../../../Notification/index.js';

const createTourPayTransaction = async ({ state, userId, addTourPayTransaction, updateState, refreshPage }) => {
  const { resource, itemDetails } = state;
  const { tourId, payTransactionId, units, jobElementId, waived, billable, internalRemark, remark,
  timeKeeperComment, cost, tourStartTime } = itemDetails;
  let parameters = {
    tourId,
    payTransactionId,
    units: units || 0,
    jobElementId: jobElementId || 0,
    waived: waived || false,
    billable: billable || false,
    internalRemark: internalRemark || " ",
    remark: remark || " ",
    timeKeeperComment: timeKeeperComment || " ",
    updatingUserId: userId,
    baseRate: cost || 0
  };
  const day = moment(tourStartTime).format('M/D/YYYY (ddd)');
  let notification = {type: 'success', message: 'Pay Transaction Added', description: `For ${resource.name} on ${day}`};
  try {
    await addTourPayTransaction(parameters);
  }
  catch(error) {
    if (!_.isEmpty(error)) {
      updateState({
        crudError: {
          failedAction: 'addTourPayTransaction',
          message: parseError(error)
        }
      });
      console.log(error);
      notification = {
        type: 'error',
        message: "Adding Pay Transaction Error",
        description: `For [${resource.name} on ${day}]: ${parseError(error)}`
      };
    }
  }
  Toast(notification);
  refreshPage();
}

export default createTourPayTransaction;
